import type { Moment } from 'moment';
import moment from 'moment';

import type IAttendanceRecord from '@src/models/interfaces/attendanceRecord.interface';
import { DateUtil } from '@src/packages/utils/dates';

import { MATRIX_ATTENDANCE_CORRECTION_TYPE } from '../constants';

export type MatrixEditAttendanceFormValues = {
  requestedBy: string;
  correctionReason: string;
  newStartMarking: Moment | null;
  newEndMarking: Moment | null;
  newBreakStartMarking: Moment | null;
  newBreakEndMarking: Moment | null;
  /** UI value: justified_absence | unjustified_absence */
  leaveExcuse: string | null;
  absenceReason: string | null;
};

const toMoment = (value?: { _seconds?: number } | null): Moment | null => {
  const ms = DateUtil.getTimestampMs(value ?? null);
  if (ms == null) return null;
  return moment(ms);
};

export const buildInitialEditAttendanceValues = (
  record: IAttendanceRecord,
): MatrixEditAttendanceFormValues => ({
  requestedBy: 'SUPERVISOR',
  correctionReason: MATRIX_ATTENDANCE_CORRECTION_TYPE.TIME_ADJUSTMENT,
  newStartMarking: toMoment(record.actualStartAt) ?? toMoment(record.scheduledStartAt),
  newEndMarking: toMoment(record.actualEndAt) ?? toMoment(record.scheduledEndAt),
  newBreakStartMarking:
    toMoment(record.actualBreakStartAt) ?? toMoment(record.scheduledBreakStartAt),
  newBreakEndMarking: toMoment(record.actualBreakEndAt) ?? toMoment(record.scheduledBreakEndAt),
  leaveExcuse: null,
  absenceReason: null,
});

/** Epoch milliseconds for `newAttendanceEvent` shiftChanges times (omit when invalid). */
export const markingToEpochMs = (value: Moment | null | undefined): number | undefined => {
  if (!value || !moment.isMoment(value) || !value.isValid()) return undefined;
  return value.valueOf();
};
